import { ToggleButton, ToggleButtonGroup, ToggleButtonGroupProps } from '@mui/material'
import { MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'

type Phase = 1 | 3

export interface PhaseToggleButtonGroupProps extends Omit<
  ToggleButtonGroupProps,
  'exclusive' | 'children'
> {
  value: Phase | null
  /**
   * Show the single phase option first.
   */
  singlePhaseFirst?: boolean
}

export default function PhaseToggleButtonGroup({
  value,
  onChange,
  color = 'primary',
  singlePhaseFirst = false,
  ...props
}: PhaseToggleButtonGroupProps) {
  const { t } = useTranslation()

  function handleChange(event: MouseEvent<HTMLElement>, newValue: Phase | null) {
    if (newValue !== null && newValue !== value) {
      onChange?.(event, newValue)
    }
  }

  return (
    <ToggleButtonGroup exclusive value={value} color={color} onChange={handleChange} {...props}>
      {singlePhaseFirst && <ToggleButton value={1}>{t('singlePhase')}</ToggleButton>}
      <ToggleButton value={3}>{t('threePhase')}</ToggleButton>
      {!singlePhaseFirst && <ToggleButton value={1}>{t('singlePhase')}</ToggleButton>}
    </ToggleButtonGroup>
  )
}
